import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { LandingPage } from '../../features/marketing/LandingPage';

export const Route = createFileRoute('/$lang/')({ component: Landing });

/*
 * Thin on purpose. Everything the page needs is inside the feature slice, so the router's
 * `autoCodeSplitting` emits it as a route chunk rather than folding it into the entry.
 */
function Landing(): ReactNode {
  const { lang } = Route.useParams();

  return <LandingPage lang={lang} />;
}
